import ApiHelpers from './api-helper';

export default class BlockListRemoval {
	constructor({ elements }) {
		elements.forEach((el) => {
			this.antiForgeryToken = el.dataset?.antiForgeryToken;
			this.urlBase = '/umbraco/api/';
			this.apiEndpointSet = el.dataset?.apiEndpointSet;
			el.addEventListener('click', (e) => {
				this.removeItem(e, el.dataset?.itemKey);
			});
		});
	}

	removeItem(e, itemKey) {
		e.preventDefault();
		ApiHelpers.delete(
			this.apiEndpointSet,
			{ itemKey },
			BlockListRemoval.removeBlockItem.bind(null, e),
			null,
			this.antiForgeryToken
		);
	}

	static removeBlockItem(e) {
		let container = e.target;
		while (!container.classList.contains('block__item-container')) {
			container = container.parentElement;
		}
		const listItem = container.querySelector('.block__item');
		listItem.classList.add('block__item--hide');
		container.classList.add('block__item-container--hide');
		setTimeout(() => {
			container.ontransitionend = () => {
				container.remove();
			};
		}, 400);
	}
}
